module.exports = __webpack_public_path__ + "static/img/svip_en_title.69e8ff18.png";